var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panelTitle",attrs:{"data-icoTarget":_vm.icoTarget}},[_c('div',[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.subName)?_c('i',[_vm._v(_vm._s(_vm.subName))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }